import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
} from "@mui/material";

export default function PadronPercepcionesTabla({ registros }) {
  if (!registros || registros.length === 0) return null;

  // Formateador de fechas
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return isNaN(date) ? dateString : date.toLocaleDateString("es-AR");
  };

  return (
    <Box sx={{ mb: 2, px:4}}>
      <Typography variant="subtitle2" color="primary" sx={{fontWeight: "bold"}}>
        Registros de padrones para este cliente:
      </Typography>

      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ maxHeight: 180, overflowY: "auto", borderRadius: 1 }}
      >
        <Table size="small" stickyHeader aria-label="tabla padron percepciones">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", py: 0.5 }}>Provincia</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold", py: 0.5 }}>% Percepción</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold", py: 0.5 }}>Vigencia Desde</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold", py: 0.5 }}>Vigencia Hasta</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {registros.map((row, index) => (
              <TableRow key={index} hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell component="th" scope="row" sx={{ py: 0.5 }}>
                  {row.provincia || `Prov. ${row.id_provincia}`}
                </TableCell>
                <TableCell align="center" sx={{ py: 0.5 }}>
                  {row.percepcion !== undefined ? `${row.percepcion}%` : "-"}
                </TableCell>
                <TableCell align="center" sx={{ py: 0.5 }}>
                  {formatDate(row.fecha_vigencia_desde)}
                </TableCell>
                <TableCell align="center" sx={{ py: 0.5 }}>
                  {formatDate(row.fecha_vigencia_hasta)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}